import { render, staticRenderFns } from "./SelectOptionKidView.vue?vue&type=template&id=e5510322&scoped=true"
import script from "./SelectOptionKidView.vue?vue&type=script&lang=js"
export * from "./SelectOptionKidView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5510322",
  null
  
)

export default component.exports